export const solutionsData = {
  "procedural-security": {
    id: "01",
    title: "Procedural Security Solutions",
    subtitle: "Absolute Protection. Uncompromising Standards.",
    description: "Our procedural security solutions form the backbone of physical risk mitigation. By combining highly trained personnel with rigorous operational protocols, we create an impenetrable layer of defense for your assets, people, and operations.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_imvula-refresh/artifacts/jwzlew0c_Untitled-1.webp",
    features: [
      {
        title: "Physical & Armed Guarding",
        text: "Elite personnel trained for high-threat environments, maintaining a visible and effective deterrent."
      },
      {
        title: "Officer Training",
        text: "Officers are trained by iMvula's accredited training academies on general and site-specific security practices."
      },
      {
        title: "Procedural Audit",
        text: "A comprehensive audit and augmentation of security procedures is conducted for each site."
      },
      {
        title: "Risk Mitigation",
        text: "Comprehensive site audits and continuous threat assessments to proactively address vulnerabilities."
      }
    ]
  },
  "security-technology": {
    id: "02",
    title: "Security Technology Solutions",
    subtitle: "Visibility Beyond the Human Eye.",
    description: "We deploy cutting-edge technology to augment physical security, creating a seamless, interconnected web of surveillance and control. Our technology solutions ensure that you always have eyes on what matters most.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_imvula-refresh/artifacts/b7ek2kq7_IMG_20161104_132118.webp",
    features: [
      {
        title: "Integrated CCTV & VMS",
        text: "Advanced Video Management Systems with night vision, LPR (License Plate Recognition), and AI-driven analytics."
      },
      {
        title: "Off-site Monitoring",
        text: "24/7 surveillance from our National Command Centre, providing immediate response activation."
      },
      {
        title: "Access Control Systems",
        text: "Biometrics, RFID tags, and automated vehicle management solutions for strict perimeter control."
      },
      {
        title: "Body Cameras",
        text: "Equipping officers with live-streaming body cameras for indisputable incident recording and real-time oversight."
      }
    ]
  },
  "mobile-app": {
    id: "03",
    title: "Mobile App & Web Platform",
    subtitle: "Real-time Intelligence in Your Hands.",
    description: "The iMvula Mobile App bridges the gap between field operations and management oversight. It provides absolute transparency, immediate reporting, and rapid emergency response capabilities directly from any smart device.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_imvula-refresh/artifacts/h4hao9an_Two%20Screen%20Phone%20App%20Preview%202025.webp",
    features: [
      {
        title: "Geo-location Panic Buttons",
        text: "Instant distress signaling with precise GPS coordinates for immediate tactical or medical response."
      },
      {
        title: "Electronic Occurrence Book",
        text: "Digital logging of all incidents and patrols, replacing outdated paper systems with searchable, secure data."
      },
      {
        title: "Live KPI Reporting",
        text: "Customizable dashboards showing real-time metrics on security performance, incidents, and guard patrols."
      },
      {
        title: "Electronic Health & Safety File",
        text: "Digital Health and Safety file management ensuring documents are updated in real-time."
      }
    ]
  },
  "methodology": {
    id: "04",
    title: "Management & Methodology",
    subtitle: "Engineered for Certainty.",
    description: "Our operational methodology is built on four core pillars: Predict, Prevent, Respond, and Manage. Ensuring procedural compliance and total transparency through quality management systems and real-time reporting tools for clients.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_imvula-refresh/artifacts/1ybm1fua_Management%20Team.png",
    features: [
      {
        title: "Quality Management for Security",
        text: "iMvula holds ISO 9001:2015 Quality Management and ISO 18788:2015 Security Operations Management Systems certification, evidence of our commitment to quality."
      },
      {
        title: "Systems-enabled Quality Management",
        text: "Service delivery is managed by iMvula's internal management system, and transparency given through our customer-facing Mobile App."
      },
      {
        title: "Performance Measurement",
        text: "Measurement of performance through regular Key Performance Indicator (KPI) assessments."
      },
      {
        title: "Management Involvement",
        text: "Direct access to operational management, with access all the way up to our CEO."
      }
    ]
  },
  "specialised-services": {
    id: "05",
    title: "Specialised Services",
    subtitle: "Advanced Solutions for Complex Threats.",
    description: "When standard security measures are not enough, our specialized divisions provide elite, highly trained personnel and equipment designed to tackle extreme environments, critical intelligence gathering, and specialized protection needs.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_imvula-refresh/artifacts/pejzbb52_tacticaL.webp",
    features: [
      {
        title: "Tactical Intervention",
        text: "Specialized rapid response units capable of neutralizing complex threats, riot control, and strike intervention."
      },
      {
        title: "Investigations & Intelligence",
        text: "Dedicated teams conducting deep background checks, corporate investigations, and continuous intelligence gathering."
      },
      {
        title: "Armed Escorting",
        text: "Highly trained tactical escorts to ensure the secure transit of high-value goods and personnel."
      },
      {
        title: "Close Protection Services",
        text: "Discreet, highly skilled close protection officers ensuring the safety of key personnel and VIPs, including the deployment of armoured vehicles."
      }
    ]
  }
};
